import { MapPin, MessageCircle, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function VisitOurCampus() {
  return <section data-section-id="234010" id="find-us-in-irving" className="w-full bg-background text-foreground">
      <div className="flex flex-col lg:flex-row w-full min-h-[600px]">
        
        {}
        <div className="w-full lg:w-[40%] bg-card text-card-foreground p-8 md:p-12 lg:p-16 flex flex-col justify-center relative overflow-hidden">
          {}
          <div className="absolute inset-0 bg-gradient-to-br from-card to-background z-0"></div>
          
          <div className="relative z-10">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-8 tracking-wider uppercase">
              Find Us in Irving
            </h2>

            <div className="flex items-start gap-5 mb-12">
              <div className="bg-primary/10 p-4 rounded-full shrink-0 border border-primary/20">
                <MapPin className="w-7 h-7 text-primary" />
              </div>
              <div className="pt-1">
                <h3 className="font-default text-xl font-semibold mb-2 text-primary tracking-widest uppercase text-sm">
                  Our Location
                </h3>
                <p className="text-foreground/90 leading-relaxed text-lg font-medium font-default">
                  2851 Esters Rd<br />
                  Irving, TX 75062
                </p>
              </div>
            </div>

            <div className="mt-4">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground h-16 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 w-full sm:w-auto group">
                <Link to="https://wa.me/19726009309" newTab>
                  <MessageCircle className="w-7 h-7 mr-3 group-hover:scale-110 transition-transform" />
                  <span className="text-lg font-semibold tracking-wide uppercase font-default">Order via WhatsApp</span>
                </Link>
              </Button>
              <p className="mt-4 text-muted-foreground font-medium ml-2 sm:ml-6 flex items-center gap-2 font-default">
                <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
                972-600-9309
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="w-full lg:w-[60%] relative min-h-[400px] lg:min-h-auto bg-muted overflow-hidden group">
          {}
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/sultani_grill_irving_map.png)] bg-cover bg-center transition-transform duration-1000 group-hover:scale-105 opacity-60 grayscale contrast-125"></div>
          
          {}
          <div className="absolute inset-0 bg-background/40 mix-blend-multiply"></div>

          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center z-20">
            {}
            <div className="bg-secondary text-secondary-foreground p-4 rounded-full shadow-2xl border-4 border-background relative z-10 transform transition-transform group-hover:-translate-y-2 duration-300">
              <Building2 className="w-8 h-8 text-primary" />
            </div>
            {}
            <div className="w-6 h-6 bg-secondary rotate-45 -mt-3 border-r-4 border-b-4 border-background shadow-xl transform transition-transform group-hover:-translate-y-2 duration-300"></div>
            
            {}
            <div className="absolute top-4 left-1/2 -translate-x-1/2 w-16 h-16 bg-primary/30 rounded-full animate-ping -z-10"></div>
            
            {}
            <div className="w-12 h-3 bg-black/60 rounded-[100%] mt-2 blur-sm transform transition-transform group-hover:scale-75 duration-300"></div>
          </div>
          
          {}
          <Link to="https://maps.google.com/?q=2851+Esters+Rd+Irving+TX+75062" newTab className="absolute inset-0 z-30" aria-label="Open location in Google Maps">
            <span className="sr-only">Open map</span>
          </Link>
        </div>

      </div>
    </section>;
}